/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef } from 'react';
import { useLocation, Route, Switch } from 'react-router-dom';

import AuthFooter from 'components/Footers/AuthFooter.js';

import routes from 'routes.js';

function Auth() {
  const location = useLocation();
  const mainContentRef = useRef();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    document.body.classList.add('bg-gradient-purple');

    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.remove('bg-gradient-purple');
    };
  });

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);

  return (
    <>
      <div className="main-content" ref={mainContentRef}>
        <Switch>
          {routes.map((prop, key) => {
            if (prop.layout === '/auth') {
              return (
                <Route
                  key={key}
                  path={prop.layout + prop.path}
                  component={prop.component}
                />
              );
            } else {
              return null;
            }
          })}
        </Switch>
      </div>
      <AuthFooter />
    </>
  );
}

export default Auth;
